module.exports = __webpack_public_path__ + "/img/PLCC-Labeled-jKb2WX.svg";